
const memberTypeChecker = {
    step1: {

    },
    step2: {
        activePhysician: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'AFF-PHD', 'AFF-NON'].includes(appType);
        },
        resident: function (appType) {
            return ['ATR-RF', 'ATR-MIL'].includes(appType);
        },
        medical: function (appType) {
            return ['ATR-MED', 'ATR-MEDM'].includes(appType);
        },
        trainer: function (appType) {
            return ['ATR-NON', 'AA-S'].includes(appType);
        },
        careTeamProvider: function (appType) {
            return ['CRTM-EDU', 'CRTM-AA'].includes(appType);
        },
        hideCredentials: function (appType) {
            return ['ATR-MED', 'INT-MED'].includes(appType);
        },
        emailLocationIsHome: function (appType) {
            return ['ATR-RF', 'ATR-MIL', 'ATR-MED', 'ATR-MEDM', 'ATR-NON', 'AA-S', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        hideDistrict: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON','CRTM-AA', 'CRTM-EDU', 'CRTM-PAE', 'AA-S', 'ATR-NON'].includes(appType);
        },
    },
    step3: {
        //Address type changes to "Home"
        addressTypeIsHomeByDefault: function (appType) {
            return ['ATR-RF', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Don't default country to "United States"; Use International Address fields
        internationalAddressFields: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        }
    },
    step4: {
        //"State of Primary Practice" info icon content to "Equals medical school institution state."
        stateOfPrimaryPracticeInfoExceptionA: function (appType) {
            return ['ATR-RF'].includes(appType);
        },
        //"State of Primary Practice" info icon content to "Equals medical school institution state."
        stateOfPrimaryPracticeInfoExceptionB: function (appType) {
            return ['ATR-MED'].includes(appType);
        },
        //"State of Primary Practice" info icon content to "Equals training program state."
        stateOfPrimaryPracticeInfoExceptionC: function (appType) {
            return ['ATR-NON', 'AA-S'].includes(appType);
        },
        //Hide "State of Primary Practice" field and hard-code to "Other - International"
        skipStep4: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Hide "State of Primary Practice" field and hard-code to "Other - International"
        stateOfPrimaryPracticeHide: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Hide "District" field for these membership types
        districtHide: function (appType) {
            return ['CRTM-AA', 'CRTM-EDU', 'CRTM-PAE', 'AA-S', 'ATR-NON'].includes(appType);
        },
        //Hide "NPI Number"
        hideNpiNumber: function (appType) {
            return ['AFF-PHD', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        requireNpiNumber: function (appType) {
            return ['ACT-MG', 'ACT-FY', 'ACT-EC', 'ACT-PA'].includes(appType);
        },
        //Hide "Active Licenses"
        hideActiveLicenses: function (appType) {
            return ['AFF-PHD', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Hide "Board Certifications"
        hideBoardCertifications: function (appType) {
            return ['AFF-PHD', 'AFF-NON', 'CRTM-EDU', 'CRTM-AA', 'CRTM-PAE', 'ATR-MED', 'ATR-MEDM', 'ATR-NON', 'AA-S', 'INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Hide "Board Credentials"
        hideBoardCredentials: function (appType) {
            return ['AFF-PHD', 'AFF-NON', 'CRTM-EDU', 'CRTM-AA', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        }
    },
    step5: {
        //Hide "Medical School" fields
        hideMedicalSchool: function (appType) {
            return ['AFF-PHD'].includes(appType);
        },
        //Change "Medical School" to "Training Program"
        changeMedicalSchoolLabel: function (appType) {
            return ['CRTM-EDU', 'CRTM-AA', 'ATR-NON', 'AA-S', 'INT-CRTM', 'INT-NON'].includes(appType);
        },
        //Don't default country to "United States"
        doNotDefaultCountryToUSA: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        // "Medical School" begin/end dates format as MM/YYYY or YYYY and assume 7/1/YYYY start, 6/30/YYYY end
        medicalSchoolDateFormatException: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'AFF-NON', 'CRTM-EDU', 'ATR-RF', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-PHY', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //Add "Program Director Name" and "Program Director Email"
        addProgramDirectorFields: function (appType) {
            return ['ATR-RF', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //The program type is hard-coded as "Medical School"
        defaultProgramTypeToMedicalSchool: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'AFF-NON', 'ATR-RF', 'ATR-MED', 'INT-PHY', 'INT-RF', 'INT-MED'].includes(appType);
        },
        //The program type is hard-coded as "Training Program"
        defaultProgramTypeToTrainingProgram: function (appType) {
            return ['CRTM-EDU', 'CRTM-AA', 'ATR-NON', 'AA-S', 'INT-CRTM', 'INT-NON'].includes(appType);
        },
        //"Residency" Education Program Type (Hidden Default to "Residency")
        defaultProgramTypeToResidency: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'ATR-RF', 'INT-PHY', 'INT-RF'].includes(appType);
        },
        //Hide "Residency" fields
        hideResidencyFields: function (appType) {
            return ['AFF-PHD', 'AFF-NON', 'CRTM-EDU', 'CRTM-AA', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-CRTM', 'INT-MED', 'INT-NON'].includes(appType);
        },
        //"Residency" begin/end dates format as MM/YYYY or YYYY and assume 7/1/YYYY start, 6/30/YYYY end
        residencyDateFormatException: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'ATR-RF', 'INT-PHY', 'INT-RF'].includes(appType);
        },
        //"Fellowship" Education Program Type (Hidden Default to "Fellowship")
        defaultProgramTypeToFellowship: function (appType) {
            return ['ACT-PA', 'ACT-MG', 'ACT-FY', 'ACT-EC', 'ATR-RF', 'INT-PHY', 'INT-RF'].includes(appType);
        },
        //Hide "Fellowship" fields
        hideFellowshipFields: function (appType) {
            return ['AFF-PHD', 'AFF-NON', 'CRTM-EDU', 'CRTM-AA', 'ATR-MED', 'ATR-NON', 'AA-S', 'INT-CRTM', 'INT-MED', 'INT-NON'].includes(appType);
        }
    },
    step6: {
        //Don't default country to "United States"; Use International Address fields
        internationalAddressFields: function (appType) {
            return ['INT-PHY', 'INT-CRTM', 'INT-RF', 'INT-MED', 'INT-NON'].includes(appType);
        }
    }
}

module.exports = memberTypeChecker;